import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Icon } from '@cld/icon';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';
import { messages } from '../../../i18n';

const Root = styled.div`
  background-color: ${globalTheme.palette.surface};
  display: flex;
  border-radius: ${globalTheme.radius.lg};
  overflow: hidden;
`;

const InfoIconContainer = styled.div`
  background: ${globalTheme.palette.primary};
  display: flex;
  align-items: center;
  padding: ${globalTheme.spacing.lg};

  & > * {
    color: ${globalTheme.palette.secondary};
    width: calc(${globalTheme.spacing.lg} + ${globalTheme.spacing.xxs});
    height: calc(${globalTheme.spacing.lg} + ${globalTheme.spacing.xxs});
  }
`;

const InfoText = styled.div`
  flex: 1;
  ${typography.md.regular};
  padding: ${globalTheme.spacing.xl};
`;

export const Info: FC = () => (
  <Root>
    <InfoIconContainer>
      <Icon name="infoOutline" />
    </InfoIconContainer>
    <InfoText>
      <FormattedMessage {...messages['afterExport.info']} />
    </InfoText>
  </Root>
);
